var React = require('react');

function UtensilFork (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M279.36 301.8l-69.21-69.2c-20.9-45-13.1-97.3 28.69-139.1C266.46 66 350.63 6.3 355 3.2c18.8-13.71 52.89 19.9 37.5 39.3L279.36 155.7c-1.7 3.79 9.5 14.69 12.89 12.89C313.65 149.4 410 63.3 412.32 61.3c19.3-14.1 52.49 19.1 38.4 38.4-2 2.2-88.09 98.6-107.28 120.1-1.8 3.4 9.09 14.6 12.89 12.9l113.18-113.2c19.4-15.3 53 18.7 39.29 37.4-3.1 4.39-62.78 88.6-90.38 116.2-41.89 42-94.08 49.6-139.06 28.7z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M98.84 503a27.24 27.24 0 0 1-38.47 2c-.34-.31-.68-.62-1-.95L8 452.75a27.18 27.18 0 0 1-.12-38.44c.36-.36.74-.72 1.12-1.06l201.11-180.69 69.21 69.2h.06z","className":"fa-primary","key":2})]);
}

UtensilFork.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = UtensilFork;

UtensilFork.default = UtensilFork;
